import { ProductData } from "@/common/types/product.type";
import z from "zod";

export const productDistributionsLimitSchema = z.object({
  id: z.string().optional(),
  product: z.custom<ProductData>(),
  maximum_value: z.string({ message: 'Campo obrigatório' }),
  maximum_quantity: z.string({ message: 'Campo obrigatório' }),
});

export const productCategoryDistributionsLimitSchema = z.object({
  maximum_value: z.string({ message: 'Campo obrigatório' }),
  maximum_quantity: z.string({ message: 'Campo obrigatório' }),
});

export const productDistributionsLimitControlledByCurrencySchema = productDistributionsLimitSchema.pick({
  id: true,
  product: true,
  maximum_value: true,
});

export const productDistributionsLimitControlledByQuantitySchema = productDistributionsLimitSchema.pick({
  id: true,
  product: true,
  maximum_quantity: true,
});

export const productCategoryDistributionsLimitControlledByCurrencySchema = productCategoryDistributionsLimitSchema.pick({
  maximum_value: true,
}).extend({
  product_distribution_limits_attributes: z.array(productDistributionsLimitControlledByCurrencySchema),
});

export const productCategoryDistributionsLimitControlledByQuantitySchema = productCategoryDistributionsLimitSchema.pick({
  maximum_quantity: true,
}).extend({
  product_distribution_limits_attributes: z.array(productDistributionsLimitControlledByQuantitySchema),
});

export type ProductDistributionLimitControlledByCurrencyValidationSchema = z.infer<typeof productDistributionsLimitControlledByCurrencySchema>;

export type ProductDistributionLimitControlledByQuantityValidationSchema = z.infer<typeof productDistributionsLimitControlledByQuantitySchema>;

export type ProductDistributionLimitValidationSchema = ProductDistributionLimitControlledByCurrencyValidationSchema | ProductDistributionLimitControlledByQuantityValidationSchema;

export type ProductCategoryDistributionLimitControlledByCurrencyValidationSchema = z.infer<typeof productCategoryDistributionsLimitControlledByCurrencySchema>;

export type ProductCategoryDistributionLimitControlledByQuantityValidationSchema = z.infer<typeof productCategoryDistributionsLimitControlledByQuantitySchema>;

export type ProductCategoryDistributionLimitValidationSchema = ProductCategoryDistributionLimitControlledByCurrencyValidationSchema | ProductCategoryDistributionLimitControlledByQuantityValidationSchema;
